import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';

const DraggableButtons = props => {
  const { items, clickHandler, showSelected } = props;
  return _.map(items, (item, index) => {
    return (
      <Draggable
        key={`draggable${item.ColName}`}
        draggableId={`draggable${item.ColName}`}
        index={index}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {
              <div
                onClick={e => {
                  e.preventDefault();
                  clickHandler(item, showSelected);
                }}
                className={classNames(
                  { 'selected-draggable-button': showSelected },
                  { 'draggable-button': !showSelected }
                )}
              >
                {item.ColLabel}
              </div>
            }
          </div>
        )}
      </Draggable>
    );
  });
};

DraggableButtons.defaultProps = {
  items: [],
  clickHandler: () => {},
};

DraggableButtons.propTypes = {
  items: PropTypes.array,
  clickHandler: PropTypes.func,
  showSelected: PropTypes.bool,
};

export default DraggableButtons;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/exportInventory/components/DraggableButtons.js